import NRVulnVoltIcon from '../../NRIcons/NRVulnVoltIcon';
import NRRemediateIcon from '../../NRIcons/NRRemediateIcon';
import NRSBOMIcon from '../../NRIcons/NRSBOMIcon';
import NRMisconfigurationIcon from '../../NRIcons/NRMisconfigurationIcon';
import NRCredentialIcon from '../../NRIcons/NRCredentialIcon';
import ActionsIcon from '../../NRIcons/ActionsIcon';
import NRAssetIcon from '../../NRIcons/NRAssetIcon';
import NRCertificateIcon from '../../NRIcons/NRCertificateIcon';
import NRGroupIcon from '../../NRIcons/NRGroupIcon';

/** Activity types that should use activityType for the icon instead of entityType. */
const ACTIVITY_TYPES_FOR_ICON = new Set([
  'VULNERABILITY_REMEDIATED',
  'ASSET_GROUP_ADDED',
  'ASSET_GROUP_REMOVED',
  'SECRET_REMEDIATED',
  'LICENSE_ISSUE_REMEDIATED',
  'GROUP_CREATED',
  'GROUP_UPDATED',
  'GROUP_DELETED',
  'GROUP_MEMBERSHIP_CHANGED',
  'ORG_SETTINGS_UPDATED',
  'ASSET_ANALYSIS_COMPLETED'
]);

export function getIconTypeFromActivityItem(item) {
  if (!item) return undefined;
  return ACTIVITY_TYPES_FOR_ICON.has(item.activityType) ? item.activityType : item.entityType;
}

export function getIconForType(type) {
  switch (type) {
    case 'ASSET':
      return <NRAssetIcon />;
    case 'ASSET_GROUP':
    case 'ORGANIZATION':
      return <NRGroupIcon width={'24'} height={'24'} />;
    case 'VULNERABILITY_UPDATED':
    case 'VULNERABILITY':
      return <NRVulnVoltIcon />;
    case 'IDENTIFICATION':
      return <NRSBOMIcon height={24} width={24} />;
    case 'MISCONFIGURATION':
      return <NRMisconfigurationIcon height={24} width={24} />;
    case 'CERTIFICATE':
    case 'PUBLIC_KEY':
    case 'PRIVATE_KEY':
      return <NRCertificateIcon height={24} width={24} />;
    case 'CREDENTIAL_USER':
    case 'CREDENTIAL_HASH':
      return <NRCredentialIcon height={24} width={24} />;
    case 'VULNERABILITY_REMEDIATED':
    case 'SECRET_REMEDIATED':
    case 'LICENSE_ISSUE_REMEDIATED':
      return <NRRemediateIcon />;
    case 'ASSET_GROUP_ADDED':
    case 'ASSET_GROUP_REMOVED':
    case 'GROUP_CREATED':
    case 'GROUP_UPDATED':
    case 'GROUP_DELETED':
    case 'GROUP_MEMBERSHIP_CHANGED':
    case 'ORG_SETTINGS_UPDATED':
      return <NRGroupIcon width={'24'} height={'24'} />;
    case 'ASSET_ANALYSIS_COMPLETED':
      return <NRAssetIcon />;
    default:
      return <ActionsIcon />;
  }
}

/**
 * Icon for activity feed / notification rows.
 * Pass `item` (activity feed) or `type` (notifications / explicit type).
 */
function NRActivityFeedIcon({ item, type }) {
  const resolvedType = type ?? getIconTypeFromActivityItem(item);
  return getIconForType(resolvedType);
}

export default NRActivityFeedIcon;
